export default "__VITE_ASSET__BsFddT7V__"